import { IActivityConfiguration } from '../interfaces/IActivityComponent';

export class ActivityConfigurations {
    private static _activityConfigurations: IActivityConfiguration[] = [];

    public static register(_annotation: {}): ClassDecorator {
        return <TFunction extends Function>(target: TFunction) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ActivityConfigurations._activityConfigurations.push(new (target as any)());
        };
    }
}
